module.exports = __webpack_public_path__ + "img/group-toggle-off.6b2bbb2e.svg";